import router from './router/lazy'
import store from './store'

// const whiteList = ['/login']
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    if (store.getters.userInfo === '') {
      store.dispatch('GetUserInfo').then(res => {
        store.dispatch('GenerateRoutes', res.data.data.loginTenant.loginDepartment.systemAuths).then(res => {
          router.addRoutes(res)
          let clickSystemMenu = localStorage.getItem('clickSystemMenu')
          if (clickSystemMenu) {
            store.dispatch('fillChildMenuOnSystemClick', JSON.parse(clickSystemMenu)).then(res => {
              next({...to, replace: true})
            })
          } else {
            next({...to, replace: true})
          }
        })
      }).catch(() => {
        console.log('获取用户信息失败！！！')
        next()
      })
    } else {
      next()
    }
  }
})

router.afterEach(() => {
})



// WEBPACK FOOTER //
// ./src/permission.js